export default {
    init: function (){
      const AK = "d89dd2c4a05edf4e1c1694ad2094d2af";
      // 设置安全密钥
      window._AMapSecurityConfig = {
        securityJsCode: '4c1e92625a9bf3bc2721d43a1d4e6443',
      }
      const AMap_URL = "https://webapi.amap.com/maps?v=2.0&key="+ AK +"&callback=onMapCallback&plugin=AMap.PlaceSearch,AMap.AutoComplete,AMap.Geocoder,AMap.GeometryUtil,AMap.MouseTool";
      return new Promise((resolve, reject) => {
        // 如果已加载直接返回
        if(typeof AMap !== "undefined") {
          resolve(AMap);
          return true;
        }
        // 地图异步加载回调处理
        window.onMapCallback = function () {
          resolve(AMap);
        };
  
        // 插入script脚本
        let scriptNode = document.createElement("script");
        scriptNode.setAttribute("type", "text/javascript");
        scriptNode.setAttribute("src", AMap_URL);
        document.body.appendChild(scriptNode);
      });
    }
  } 
